<ng-container *ngFor="let field of fields">
  <div [ngClass]="columnClass">
    <div class="form-group" [ngSwitch]="field.dataType"
         [class.has-error]="showError(field)">
      <label class="control-label">{{ field.name }} <i *ngIf="field.isRequired">*</i></label>

      <!-- Text -->
      <input *ngSwitchCase="types.Text" type="text" class="form-control" maxlength="500"
             [name]="'cf_' + field.id" [(ngModel)]="model[field.id]" (ngModelChange)="emit()"
             [required]="field.isRequired" [disabled]="disabled" />

      <!-- Number -->
      <input *ngSwitchCase="types.Number" type="number" class="form-control"
             [name]="'cf_' + field.id" [(ngModel)]="model[field.id]" (ngModelChange)="emit()"
             [required]="field.isRequired" [disabled]="disabled" />

      <!-- Yes / No: a checkbox like the form's own Active field (checked = True, unchecked = False) -->
      <div *ngSwitchCase="types.Boolean" class="checkbox">
        <label>
          <input type="checkbox" [checked]="model[field.id] == 'True'" [disabled]="disabled"
                 (change)="setBoolean(field, $event.target.checked)" /> {{ field.name }}
        </label>
      </div>

      <!-- Date (native picker returns yyyy-MM-dd, no timezone shift) -->
      <input *ngSwitchCase="types.Date" type="date" class="form-control"
             [name]="'cf_' + field.id" [(ngModel)]="model[field.id]" (ngModelChange)="emit()"
             [required]="field.isRequired" [disabled]="disabled" />

      <!-- Single choice -->
      <select *ngSwitchCase="types.SingleChoice" class="form-control"
              [name]="'cf_' + field.id" [(ngModel)]="model[field.id]" (ngModelChange)="emit()"
              [required]="field.isRequired" [disabled]="disabled">
        <option value=""></option>
        <option *ngFor="let o of choicesOf(field)" [value]="'' + o.id">{{ o.value }}</option>
      </select>

      <!-- Multiple choice: a multi-select dropdown (required = at least one choice) -->
      <span *ngSwitchCase="types.MultipleChoice" class="ui-fluid">
        <p-multiSelect [options]="multiOptions[field.id]" appendTo="body"
                       [name]="'cf_' + field.id" [(ngModel)]="model[field.id]" (ngModelChange)="emit()"
                       [required]="field.isRequired" [disabled]="disabled"
                       [defaultLabel]="field.name"></p-multiSelect>
      </span>

      <div *ngIf="showError(field)" class="jquery-validate-error help-block">
        {{ field.name }} {{'customFields.isRequired' | translate}}
      </div>
    </div>
  </div>
</ng-container>
